import React from 'react';
import { Card, Box, Typography } from '@mui/material';
import ButtonComponent from "../Reusable/PrimaryButton/PrimaryButton";
import Popup from '../Popup/GalleyPopup';
import { useLocation } from 'react-router-dom';

interface ImageId {
  _id: string;
  url: string;
  caption: string;
}
interface UploadImageCardProps {
  image: string | null;
  onDelete?: () => void;
  onUploadClick?: () => void;
  onFileChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef?: React.RefObject<HTMLInputElement>;
  disabled?: boolean;
  multiple?: boolean;
  selectedImageId?: any | null;
  setSelectedImageId?: (image: ImageId | null) => void;
  setVoiceDetails?: any
  setUserProfileIcon?: any
  setVoiceType?:any
  voiceDetails?: any
}

const UploadImageCard: React.FC<UploadImageCardProps> = ({
  image,
  onDelete,
  onUploadClick,
  onFileChange,
  fileInputRef,
  disabled,
  selectedImageId,
  setSelectedImageId,
  setVoiceType,
  setVoiceDetails,
  voiceDetails,
  setUserProfileIcon,
  multiple
}) => {
  const [openModel, setOpenModel] = React.useState(false);
  const [selectionMode, setSelectionMode] = React.useState<'card' | 'image'>('card');


  const handleGalleryImage = () => {
    setOpenModel(true);
    setUserProfileIcon?.(false);
    setSelectionMode('card');
     setSelectedImageId?.(null);
  }

  const location = useLocation();
  const hideUploadImage = location.pathname.startsWith('/humanpersona/model')
  const productScapePage = location.pathname.includes('/idea-board/Productscape');


  return (

    <>
      <Card className='UploadCardPod'>
        {(selectedImageId?.url || image)? (
          <>
            <img src={ selectedImageId?.url|| image } alt='Uploaded' style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            <img src={'/assets/Deletedicon.svg'} alt='DeletedIcon' className='DeletedIcon' onClick={onDelete} />
          </>
        ) : (
          <Box className="uploadBox">
            <div>
              <img src={'/assets/Vector.svg'} alt="Upload Icon" className="uploadIcon" onClick={onUploadClick} />
              <Typography className="uploadText">Upload Image From</Typography>
              {!hideUploadImage && (
                 <div className="containerbtn">
                <ButtonComponent onClick={onUploadClick} >Computer</ButtonComponent>
                {!productScapePage &&  <ButtonComponent className="nonStyledbtn" onClick={handleGalleryImage} >Persona</ButtonComponent>}
              </div>
              )}
              {/* Hidden file input */}
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept="image/*"
                onChange={onFileChange}
                multiple={false}
              />

            </div>

          </Box>
        )}
      </Card>
      {openModel && (
        <Popup
          open={openModel}
          onClose={() => {
            setOpenModel(false);
            // setUserProfileIcon?.(true);
            setVoiceType?.('');
          }}
          selectionMode={selectionMode}
          setSelectionMode={setSelectionMode}
          setSelectedImageId={setSelectedImageId}
          setVoiceDetails={setVoiceDetails}
          selectedImageId={selectedImageId}
          setVoiceType={setVoiceType}
          voiceDetails={voiceDetails}
          setUserProfileIcon={setUserProfileIcon}
        />
      )}
    </>
  )
}
export default UploadImageCard;
